import Vue from "vue";
import VueRouter from "vue-router";
import { firebase, db } from "@/main";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    redirect: "/main",
  },
  /*
  {
    path: "/password",
    name: "Password",
    component: () => import("../views/Password.vue"),
    meta: { isPublic: true },
  },
  */
  {
    path: "/register",
    name: "register",
    component: () => import("../views/Register.vue"),
    meta: { isPublic: true },
  },
  {
    path: "/reset_password",
    name: "resetPassword",
    component: () => import("../views/ResetPassword.vue"),
    meta: { isPublic: true },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/Profile.vue"),
  },
  /*
  {
    path: "/map",
    name: "map",
    component: () => import("../views/Map.vue"),
  },
  */
  {
    path: "/main",
    name: "main",
    component: () => import("../views/Stream.vue"),
  },
  {
    path: "/channels/:channel_id",
    name: "channel",
    component: () => import("../views/Channel.vue"),
  },
  {
    path: "/booths",
    name: "booth",
    component: () => import("../views/Booth.vue"),
  },
  // {
  //   path: "/topics",
  //   name: "topic",
  //   component: () => import("../views/Topic.vue"),
  // },
  // {
  //   path: "/calendar",
  //   name: "calendar",
  //   component: () => import("../views/Calendar.vue"),
  // },
  // {
  //   path: "/shift-kuji",
  //   name: "game",
  //   component: () => import("../views/Game.vue"),
  // },

  // manage
  {
    path: "/manage",
    name: "manage",
    redirect: "/manage/channels/1",
    meta: { requiresOrganizer: true },
  },
  {
    path: "/stream",
    name: "stream",
    component: () => import("../views/Stream.vue"),
    meta: { requiresOrganizer: true },
  },
  {
    path: "/manage/channels/:channel_id",
    name: "manageChannel",
    component: () => import("../views/manage/Channel.vue"),
    meta: { requiresOrganizer: true },
  },
  {
    path: "/manage/booths",
    name: "manageBooth",
    component: () => import("../views/manage/Booth.vue"),
    meta: { requiresAdmin: true },
  },
  {
    path: "/manage/mails",
    name: "manageMail",
    component: () => import("../views/manage/SendMail.vue"),
    meta: { requiresAdmin: true },
  },
  // {
  //   path: "/manage/gifts",
  //   name: "manageGift",
  //   component: () => import("../views/manage/Gift.vue"),
  //   meta: { requiresAdmin: true },
  // },
  {
    path: "/manage/user",
    name: "manageUser",
    component: () => import("../views/manage/User.vue"),
    meta: { requiresAdmin: true },
  },
  {
    path: "/manage/dashboard",
    name: "manageDashboard",
    component: () => import("../views/manage/Dashboard.vue"),
    meta: { requiresAdmin: true },
  },

  // error
  {
    path: "*",
    name: "error",
    component: () => import("../views/Error.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "is-active",
  routes,
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some((record) => record.meta.isPublic);
  const requiresAdmin = to.matched.some((record) => record.meta.requiresAdmin);
  const requiresOrganizer = to.matched.some(
    (record) => record.meta.requiresOrganizer
  );

  firebase.auth().onAuthStateChanged(async (user) => {
    if (isPublic) {
      // 認証不要
      next();
    } else {
      // 認証が必要
      if (!user) {
        // 未ログイン
        store.commit("user", null);
        next({ name: "register", query: { redirect: to.fullPath }, hash: '#login' });
      } else {
        // ログイン済み
        // User invited by email that will not have display name.
        // If user has not display, we will use email.
        const userRef = await db.collection("profiles").doc(user.uid).get()
        const userData = userRef.data() || {}
        const userContents = {
          uid: user.uid,
          email: user.email,
          displayName: user.displayName || userData.displayName || 'ゲスト',
        };
        store.commit("user", userContents);

        user.getIdToken(true).then(() => {
          user.getIdTokenResult().then((idTokenResult) => {
            const claims = idTokenResult.claims;
            const isAdmin = claims.admin;
            const isOrganizer = claims.organizer;

            if (requiresAdmin && !isAdmin) {
              next({ name: "error", query: { code: "unauthorized" } });
            } else if (requiresOrganizer && !isAdmin && !isOrganizer) {
              next({ name: "error", query: { code: "unauthorized" } });
            } else {
              next();
            }
          });
        });
      }
    }
  });
});

export default router;
